import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getJournalTemplates } from '../../stores/slices/journalTemplates/journalTemplatesActions';

const TemplateModal = ({ isOpen, onClose }) => {
  const { journalTemplates, listLoading } = useSelector(
    state => state.journalTemplates
  );
  const dispatch = useDispatch();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  useEffect(() => {
    dispatch(getJournalTemplates());
    // eslint-disable-next-line
  }, []);

  return (
    <Modal
      onClose={() => onClose(false)}
      size={'xs'}
      isOpen={isOpen}
      blockScrollOnMount={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select template</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {listLoading ? (
            <Spinner color="primary" />
          ) : journalTemplates.length > 0 ? (
            <Box w={'full'}>
              {journalTemplates.map(template => (
                <Button
                  variant={'outline'}
                  key={template.id}
                  color={'black'}
                  mb={'2'}
                  size={'sm'}
                  w={'full'}
                  justifyContent={'start'}
                  onClick={() => setSelectedTemplate(template)}
                  isActive={
                    selectedTemplate
                      ? template.id === selectedTemplate.id
                      : false
                  }
                  _active={{ background: 'primary', color: 'white' }}
                >
                  {template.name}
                </Button>
              ))}
            </Box>
          ) : (
            <Text>No Templates found.</Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            mr={3}
            onClick={() => {
              onClose(selectedTemplate);
              setSelectedTemplate(null);
            }}
          >
            Select
          </Button>
          <Button variant="outline" onClick={() => onClose(false)}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TemplateModal;
